import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import LandingView from "../views/LandingView.vue";
import LegalView from "../views/LegalView.vue";
import LegalHubView from "../views/LegalHubView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "landing",
    component: LandingView,
    meta: { title: "Allading — Your people. Your conversations." },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: LegalView,
    props: { doc: "privacy" },
    meta: { title: "Privacy Policy — Allading" },
  },
  {
    path: "/terms",
    name: "terms",
    component: LegalView,
    props: { doc: "terms" },
    meta: { title: "User Agreement — Allading" },
  },
  {
    path: "/legal",
    component: LegalHubView,
    meta: { title: "Privacy & terms — Allading" },
  },
  {
    path: "/cookies",
    component: LegalView,
    props: { doc: "cookies" },
    meta: { title: "Cookies & Website Notice — Allading" },
  },
  {
    path: "/delete-account",
    component: LegalView,
    props: { doc: "deletion" },
    meta: { title: "Delete Your Allading Account — Allading" },
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    return { top: 0 };
  },
});

router.afterEach((to) => {
  if (typeof to.meta.title === "string") document.title = to.meta.title;
});

export default router;
